// Helpers PUROS del color de progreso del bloque (silueta en LOD/overview). Sin motor de
// render ni `this`: solo reciben las entidades y los datos de estado ya resueltos.

// Interpolación lineal entre dos colores RGB. Por defecto gris → verde.
export function rampColor(pct, from = [224, 224, 224], to = [0, 191, 70]) {
  const p = Math.max(0, Math.min(1, pct || 0))
  const r = Math.round(from[0] + (to[0] - from[0]) * p)
  const g = Math.round(from[1] + (to[1] - from[1]) * p)
  const b = Math.round(from[2] + (to[2] - from[2]) * p)
  return 'rgb(' + r + ',' + g + ',' + b + ')'
}

// Color de la silueta de un bloque según el modo:
//  - progreso:    % de entidades COMPLETADAS (is_completion) → rampa gris→verde
//  - incidencias: % de entidades con INCIDENCIA              → rampa gris→rojo
// `entities` = array del bloque; `data` = estado de la vista
// ({ statuses, incidents, completionStatusIds }); `opts` = { picId, statusMode, noStatusColor }.
export function blockProgressColor(entities, data, { picId, statusMode, noStatusColor } = {}) {
  if (!entities || !entities.length) return noStatusColor
  if (!data) return noStatusColor

  if (statusMode === 'incidents') {
    const incidents = data.incidents || {}
    let withIncident = 0
    for (const e of entities) {
      if (incidents[picId + ':' + e.id] != null) withIncident++
    }
    return rampColor(withIncident / entities.length, [224, 224, 224], [224, 53, 53])
  }

  const completion = new Set((data.completionStatusIds || []).map(String))
  let done = 0
  for (const e of entities) {
    const statusId = data.statuses[picId + ':' + e.id]
    if (statusId != null && completion.has(String(statusId))) done++
  }
  return rampColor(done / entities.length)
}
